import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-397e30b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "solar-signup-banner py-4 text-center flex-centered flex-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-tertiary" }, "Sign up & switch to solar", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "text-decoration-none my-5 mx-3",
      to: { name: 'Apply' }
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })
  ]))
}